import { Dropdown } from "react-bootstrap";
import { CommonInput } from "../../../Input";

const AmountStep = ({
  amount,
  setAmount,
  selectedCurrency,
  setSelectedCurrency,
  currencies,
}) => {
  const formatAmount = (val) => {
    if (!val && val !== "0") return "";

    // Remove leading zeros unless it's "0." or just "0"
    let cleanVal = val;
    if (
      cleanVal.length > 1 &&
      cleanVal.startsWith("0") &&
      cleanVal[1] !== "."
    ) {
      cleanVal = cleanVal.replace(/^0+/, "");
      if (cleanVal === "") cleanVal = "0";
    }

    const parts = cleanVal.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Limit to 2 decimal places
    if (parts[1]) {
      parts[1] = parts[1].substring(0, 2);
    }

    return parts.join(".");
  };

  const handleChange = (e) => {
    let rawValue = e.target.value.replace(/,/g, "");

    // Allow empty, single dot (will become 0.), or valid numeric/decimal
    if (rawValue === "") {
      setAmount("");
      return;
    }

    if (rawValue === ".") {
      setAmount("0.");
      return;
    }

    // Validate: only numbers and at most one decimal point
    if (/^\d*\.?\d*$/.test(rawValue)) {
      setAmount(formatAmount(rawValue));
    }
  };

  return (
    <div className="pt-0">
      <p className="fw-bold text-black mb-2 fs-5">Top up amount</p>
      <div className="d-flex gap-2 align-items-start">
        <Dropdown className="currency-dropdown-group">
          <Dropdown.Toggle
            variant="light"
            className="d-flex align-items-center justify-content-between bg-white shadow-none"
            style={{
              height: "46px",
              border: "1px solid #d5dfe7",
              borderRadius: "0.75rem",
              padding: "0 20px",
              minWidth: "130px",
            }}
          >
            <div className="d-flex align-items-center">
              <img
                src={selectedCurrency.flag}
                alt={selectedCurrency.code}
                className="rounded-circle me-2"
                style={{
                  width: "24px",
                  height: "24px",
                  objectFit: "cover",
                }}
              />
              <span
                className="fw-bold text-black fs-15"
                style={{ letterSpacing: "0.5px" }}
              >
                {selectedCurrency.code}
              </span>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="border-0 shadow-lg rounded-3 py-0 mt-2 dropdown-currency-menu"
            style={{ minWidth: "260px" }}
          >
            <div className="py-2">
              {currencies.map((curr) => (
                <Dropdown.Item
                  key={curr.code}
                  className="d-flex align-items-center justify-content-between px-3 py-2 cursor-pointer"
                  onClick={() => setSelectedCurrency(curr)}
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={curr.flag}
                      alt={curr.code}
                      className="rounded-circle me-3"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "cover",
                      }}
                    />
                    <span className="text-black fw-medium fs-14">
                      {curr.name}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="text-muted fs-13 me-3">{curr.code}</span>
                    {selectedCurrency.code === curr.code && (
                      <i className="fas fa-check text-muted fs-12"></i>
                    )}
                  </div>
                </Dropdown.Item>
              ))}
            </div>
          </Dropdown.Menu>
        </Dropdown>

        <div className="flex-fill">
          <CommonInput
            type="text"
            className="fs-20 fw-bold text-black amount-field-premium"
            value={amount}
            onChange={handleChange}
            placeholder="0"
            height="56"
          />
        </div>
      </div>
    </div>
  );
};

export default AmountStep;
